export const newLabels = [
  {
    key: 'dashboard',
    label: 'My Dashboard'
  },
  {
    key: 'metrics',
    label: 'Overview'
  },
  {
    key: 'configurator',
    label: 'My Organization'
  },
  {
    key: 'OrganisationFacilities',
    label: 'About the Company'
  },
  {
    key: 'valueChainManagement',
    label: 'Value Chain'
  },
  {
    key: 'DataManagement',
    label: 'Emission Factor Databases'
  },
  {
    key: 'NZM',
    label: 'Emissions Analytics'
  },
  {
    key: 'orgManager',
    label: 'Data Collection'
  },
  {
    key: 'InfrastructureProfile',
    label: 'Resource Utilization'
  },
  {
    key: 'Product',
    label: 'Product Lifecycle'
  },
  {
    key: 'Emission Factor Database',
    label: 'Emission Factor Databases'
  },
  {
    key: 'AssetManager',
    label: 'Asset & Franchises'
  },
  {
    key: 'Supply Chain',
    label: 'Supply Chain & Transport'
  },
  {
    key: 'Processing Of Sold Products (B2B)',
    label: 'Processing of Sold Products (B2B)'
  },
  {
    key: 'utilities',
    label: 'Utilities'
  },
  {
    key: 'UseOfSoldProductsB2C',
    label: 'Use of Sold Products (B2C)'
  },
  {
    key: 'EnergyConsumptions',
    label: 'Energy Consumption'
  },
  {
    key: 'UpStreamDownStreamData',
    label: 'Upstream & Downstream Data'
  },
  {
    key: 'external',
    label: 'External'
  },
  {
    key: 'input',
    label: 'Input'
  },
  {
    key: 'OtherActivities',
    label: 'Other Activities'
  },
  {
    key: 'RawMaterial',
    label: 'Raw Material'
  },
  {
    key: 'Organisation Hierarchy',
    label: 'Organization Hierarchy'
  }
];
export const userDrawerFormKey = {
  NAME: 'name',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMAIL: 'emailAddress',
  MOBILE: 'phoneNumber',
  ADD_MEMBER_FORMS: 'addMemberForms'
};
export const userDrawerFormLabel = {
  NAME: 'Name',
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  EMAIL: 'Email',
  MOBILE: 'Mobile Number'
};
export const countryCodeIndia = '+91';
